import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Globals } from '../globals';
import { environment } from 'src/environments/environment';
declare var $, Swal: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  public authUrl: string;
  constructor(
    private AuthService: AuthService,
    private router: Router,
    public globals: Globals,
  ) {
    this.authUrl = environment.authUrl;
  }

  ngOnInit(): void {
    const body = document.querySelector('body');
    body.style.setProperty('--screen-height', $(window).height() + 'px');

    $(document).on('click', function (event) {
      var $trigger = $('.header_dropdown');
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $('.header_dropdown .dropdown-menu').removeClass('show');
        $('.header_dropdown').removeClass('show');
      }
      $('.header_dropdown .dropdown-menu a').on('click', function (event) {
        $('.header_dropdown .dropdown-menu').removeClass('show');
        $('.header_dropdown').removeClass('show');
      });
    });
    $(document).on('click', function (event) {
      var $trigger = $('.nagivation_block');
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $('.nagivation_block .navbar-collapse').removeClass('show');
        $('.nagivation_block .navbar-toggler').addClass('collapsed');
      }
      $('.nagivation_block .dropdown-menu a').on('click', function (event) {
        $('.nagivation_block .navbar-collapse').removeClass('show');
        $('.nagivation_block .navbar-toggler').addClass('collapsed');
      });
    });
  }

  logout() {
    Swal.fire({
      icon: 'warning',
      title: 'Logout',
      text: 'Are you sure you want to logout?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        this.globals.isLoading = true;
        this.AuthService.logout().then(
          (data) => {
            window.location.href = this.globals.amsnLogoutUrl;
          },
          (error) => {
            window.location.href = this.globals.amsnLogoutUrl;
          },
        );
      }
    });
  }

  dropdown_open() {
    $('.header_dropdown').toggleClass('show');
    $('.header_dropdown .dropdown-menu').toggleClass('show');
  }
}
